import { Box, Text, HStack, Heading, Tooltip } from '@chakra-ui/react';
import { DragHandleIcon } from '@chakra-ui/icons';
import { setTeasers } from './utils';

const Details = ({ styles, sections, values, secOrIndIndex }) => {
  const className = 'dragit';
  const teasers = setTeasers(sections, values, secOrIndIndex);
  return (
    <HStack>
      <Tooltip
        label="grab to re-order"
        placement="top"
        hasArrow
        bg="GRAY"
        color="WHITE"
        fontWeight={600}
        borderRadius={99}
      >
        <DragHandleIcon
          display={['none', null, 'block']}
          className={className}
          color="ORANGE_TEXT"
          cursor="grab"
        />
      </Tooltip>
      <Box sx={{ ...styles.summary.detailsDisplay }}>
        <Heading sx={{ ...styles.summary.head }}>{teasers.head}</Heading>
        <Text sx={{ ...styles.summary.subhead }}>{teasers.subhead}</Text>
        <Text>{teasers.dates}</Text>
      </Box>
    </HStack>
  );
};

export default Details;
